import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Component, OnInit, Input } from "@angular/core";
import { formMange } from "../../../classes/formClass/formVaild";
import { FacadeService } from "../../../service/facade.service";
import { DataLayerService } from "../../../service/datalayer/datalayer.service";

@Component({
  selector: "app-interested-form",
  templateUrl: "./interested-form.component.html",
  styleUrls: ["./interested-form.component.scss"]
})
export class InterestedFormComponent extends formMange implements OnInit {
  interestinForm: FormGroup;
  @Input() product_id;
  constructor(
    private _facadeService: FacadeService,
    private dataLayer: DataLayerService
  ) {
    super();
    this.createForm();
  }

  ngOnInit() {}

  createForm() {
    this.interestinForm = new FormGroup({
      name: new FormControl("", Validators.required),
      phone: new FormControl("", Validators.required),
      email: new FormControl("", [Validators.required, Validators.email]),
      message: new FormControl("", [
        Validators.required,
        Validators.minLength(10)
      ])
    });

    this.setForm(this.interestinForm);
  }

  // send intersting message to api
  intersting() {
    // check form validate
    if (!this.isFormValid) {
      return;
    }

    // get request body
    let body = this.FormValue;
    body["product_id"] = this.product_id;
    // api request
    this._facadeService.Product.interstingInProduct(body).subscribe(res => {
      this.dataLayer.setDataLayer({ event: "customer-interested" });
      this.showSuccessMessage();
    });
  }

  showSuccessMessage() {
    this.form.reset();
    this._facadeService.Alert.AlertNewmessege({
      type: "success",
      message: "thank you , we will call you soon"
    });
  }
}
